import { render, staticRenderFns } from "./recipe-categories.vue?vue&type=template&id=031b2c68&"
import script from "./recipe-categories.vue?vue&type=script&lang=js&"
export * from "./recipe-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports